// Potion: bg handled via CSS parallax in page components, not CSS background
// backgroundStyles is kept empty for compatibility
const potionBackground = {};

const backgroundStyles = {
  Tickets: potionBackground,
  MyPage: potionBackground,
  Quests: potionBackground,
  HowToUse: potionBackground,
  News: potionBackground,
  EmailSettings: potionBackground,
  ExchangeMoney: potionBackground,
  ConfirmPayPay: potionBackground,
  CheckPayPayStatus: potionBackground,
  PayPayPolling: potionBackground,
  PayPayConfirm: potionBackground,
};

export default backgroundStyles;
